import { CheckSquare, Users, X } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface DailyHubWelcomeProps {
  onDismiss: () => void;
}

export function DailyHubWelcome({ onDismiss }: DailyHubWelcomeProps) {
  return (
    <div className="p-4 bg-gradient-to-br from-teal-50 via-background to-rose-50 dark:from-teal-950/30 dark:via-background dark:to-rose-950/30 border-b border-border">
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-sm font-semibold text-foreground">
          Welcome to your To-Do List! 👋
        </h3>
        <button 
          onClick={onDismiss}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <X className="h-4 w-4" />
        </button>
      </div>

      <div className="space-y-3">
        {/* Daily To-Do List */}
        <div className="flex items-start gap-3 p-2 rounded-lg bg-teal-100/50 dark:bg-teal-900/30">
          <div className="h-8 w-8 rounded-full bg-teal-500 flex items-center justify-center flex-shrink-0">
            <CheckSquare className="h-4 w-4 text-white" />
          </div>
          <div>
            <p className="text-sm font-medium text-teal-700 dark:text-teal-300">📝 Your Daily To-Do List</p>
            <p className="text-xs text-teal-600 dark:text-teal-400">
              Add quick tasks for today. They'll be here until you're done!
            </p>
          </div>
        </div>

        {/* Family & Friends Check-in */}
        <div className="flex items-start gap-3 p-2 rounded-lg bg-rose-100/50 dark:bg-rose-900/30">
          <div className="h-8 w-8 rounded-full bg-rose-500 flex items-center justify-center flex-shrink-0">
            <Users className="h-4 w-4 text-white" />
          </div>
          <div>
            <p className="text-sm font-medium text-rose-700 dark:text-rose-300">Family & Friends Check-in</p>
            <p className="text-xs text-rose-600 dark:text-rose-400">
              Weekly activities to enjoy with people you care about — cook, play, explore together!
            </p>
          </div>
        </div>
      </div>

      <div className="mt-4 flex justify-end">
        <Button 
          size="sm" 
          onClick={onDismiss}
          className="bg-gradient-to-r from-teal-500 to-rose-500 hover:from-teal-600 hover:to-rose-600 text-white"
        >
          Got it!
        </Button>
      </div>
    </div>
  );
}
